import React from 'react'
import { Button, FormDashboardInput as Input } from '../../../components'
import { Link, useHistory } from 'react-router-dom'

const GuestContent = ({isMobile, handleClose, setStep, data}) => {
  const history = useHistory()

  return (
    <div>
      <div className="lg:hidden">
        <p className="text-sm text-gray-444 mb-4 lg:mb-5 cursor-pointer">
          <Link to="/event/detail">
            &larr; Back
          </Link>
        </p>
      </div>
      <p
        className="hidden lg:block text-sm text-gray-444 mb-4 lg:mb-5 cursor-pointer"
        onClick={() => setStep('ticket')}
      >
        &larr; Back
      </p>
      <h1 className="text-lg lg:text-2xl mb-2 font-primary font-bold">Guests</h1>
      <p className="text-sm text-gray-444">{data.title}</p>

      <hr className="my-8 lg:my-10"/>

      <form>
        <div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-8">
            <div className="w-full lg:w-1/3 px-4 mb-4 lg:mb-0">
              Guest #1
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-4 lg:mb-0">
              <Input placeholder="Full name" className="w-full"/>
            </div>
            <div className="w-full lg:w-1/3 px-4">
              <Input placeholder="Occupation" className="w-full"/>
            </div>
          </div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-0">
            <div className="w-full lg:w-1/3 px-4 ml-auto mb-4 lg::mb-0">
              <Input placeholder="Email" className="w-full" type="email"/>
            </div>
            <div className="w-full lg:w-1/3 px-4">
              <Input placeholder="Phone" className="w-full"/>
            </div>
          </div>
        </div>
        <hr className="my-8 lg:my-10"/>
        <div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-8">
            <div className="w-full lg:w-1/3 px-4 mb-4 lg:mb-0">
              Guest #2
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-4 lg:mb-0">
              <Input placeholder="Full name" className="w-full"/>
            </div>
            <div className="w-full lg:w-1/3 px-4">
              <Input placeholder="Occupation" className="w-full"/>
            </div>
          </div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-0">
            <div className="w-full lg:w-1/3 px-4 ml-auto mb-4 lg:mb-0">
              <Input placeholder="Email" className="w-full" type="email"/>
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-4 lg:mb-0">
              <Input placeholder="Phone" className="w-full"/>
            </div>
          </div>
        </div>
        <hr className="my-8 lg:my-10"/>

        <div className="mb-8 lg:mb-10">
          <div className="flex lg:block">
            <input type="checkbox" id="agree" className="block lg:inline mt-1 lg:mt-0 mr-2"/>
            <label for="agree" className="block lg:inline text-sm text-gray-444">By clicking submit, kamu berkomitmen untuk mengikuti acara ini. Kita berhak membatasi akses pendaftaranmu jika kamu sudah berturut-turut tidak hadir dalam acara yg telah kamu daftarkan.</label>
          </div>
        </div>

        <div className="flex justify-end mb-8 lg:mb-0">
          <div className="hidden lg:block" style={{width: '170px'}} onClick={handleClose}>
            <Button>
              Submit
            </Button>
          </div>
          <div className="w-full lg:hidden">
            <Button thin onClick={() => history.push('/event/detail')}>
              Submit
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export { GuestContent }